export const JOB_STRINGS = {
    ADD_JOB: "Add Job",
    EDIT_JOB: "Edit Job",
    JOB_NAME: "Job Name",
    SEARCH_JOB: "Search Job",
    CANCEL_JOB: "Cancel Job(s)",
    DELETE_JOB: "Delete Job(s)",
    CONFIRM_DELETE: "Confirm Delete",
    CONFIRM_CANCEL: "Confirm Cancel",
    OUT_OF: "out of",
    JOBS_SELECTED: "job(s) selected",
    BE_DELETED: "will be deleted.",
    BE_CANCELLED: "will be cancelled.",
    NONE_JOBS_SELECTED: "None of the selected jobs are in a",
    DELETABLE_STATUS: "deletable status (Cancelled or Closed).",
    CANCELLABLE_STATUS: "cancellable status (Queued or Assigned).",
};

export const JOB_KEYS = {
    ID: "id",
    JOB_NAME: "jobname",
};

export const JOB_STATUS = {
    QUEUED: "queued",
    ASSIGNED: "assigned",
    CANCELLED: "cancelled",
    CLOSED: "closed",
}

export const JOB_ACTIONS = {
    CANCEL: "Cancel",
    DELETE: "Delete",
};

export const JOB_TABLE_COLUMNS = [
    { id: "select", isSortable: false, label: "Select" },
    { id: "id", isSortable: true, label: "Job ID" },
    { id: "status", isSortable: true, label: "Status" },
    { id: "enqueuedAt", isSortable: true, label: "Queue Time" },
    { id: "queueId", isSortable: true, label: "Queue" },
    { id: "priority", isSortable: true, label: "Priority" },
    { id: "skill", isSortable: true, label: "Skill" },
    { id: "operator", isSortable: true, label: "Operator" },
    { id: "skillValue", isSortable: true, label: "Skill Value" },
    { id: "workerId", isSortable: true, label: "Worker" },
    { id: "assignedAt", isSortable: true, label: "Assign Time" },
];

export const JOB_TABLE_COLUMN_KEYS = {
    SELECT: "select",
    ID: "id",
    STATUS: "status",
    QUEUE_TIME: "enqueuedAt",
    QUEUE_ID: "queueId",
    PRIORITY: "priority",
    SKILL: "skill",
    OPERATOR: "operator",
    SKILL_VALUE: "skillValue",
    WORKER_ID: "workerId",
    ASSIGNED_TIME: "assignedAt",
};

export const JOB_MESSAGES = {
    NO_JOB: "No Job(s) to display",
    JOB_DELETED: "Job(s) deleted successfully!",
    JOB_CANCELLED: "Job(s) cancelled successfully!",
};

export const JOB_ERRORS = {
    ADD_JOB_ERROR: "Error adding job:",
    SAVE_JOB_ERROR: "Error saving job:",
    UPDATE_JOB_ERROR: "Error updating job:",
    FETCH_JOB_ERROR: "Error fetching job:",
    DELETE_JOB_ERROR: "Error deleting job",
    ACCEPT_JOB_ERROR: "Error accepting job",
    CANCEL_JOB_ERROR: "Error canceling job",
};

